var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('simple-page', {
    scopedSlots: _vm._u([{
      key: "pageItem",
      fn: function fn() {
        return [_c('breadcrumb', {
          attrs: {
            "items": _vm.breadcrumbItems
          }
        }), _c('pending-items-internal', {
          attrs: {
            "title": false
          }
        })];
      },
      proxy: true
    }, {
      key: "pageTitle",
      fn: function fn() {
        return [_c('h1', {
          staticClass: "text-upper-case"
        }, [_vm._v("Pending Group Submissions")]), _c('button', {
          staticClass: "clear-search",
          on: {
            "click": _vm.clearFilter
          }
        }, [_vm._v("Clear Search")])];
      },
      proxy: true
    }, {
      key: "filter",
      fn: function fn() {
        return [_c('pending-submission-filter', {
          attrs: {
            "filters": _vm.filterQuery
          },
          on: {
            "onSearch": _vm.handleFilterChange
          }
        })];
      },
      proxy: true
    }, {
      key: "topPagination",
      fn: function fn() {
        return [_c('div', {
          staticClass: "top-pagination d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-3 mb-2"
        }, [_c('pagination', {
          staticClass: "m-0",
          attrs: {
            "rows": _vm.groupRows,
            "filters": _vm.filterQuery
          },
          on: {
            "update:rows": function updateRows($event) {
              _vm.groupRows = $event;
            }
          }
        }), _vm.selectedItems.length > 1 ? _c('button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.bulkApproval",
            modifiers: {
              "bulkApproval": true
            }
          }],
          staticClass: "btn-bulk mt-0 mb-2 univ-btn"
        }, [_vm._v(" Bulk Submit Enrollment ")]) : _vm._e(), _vm.selectedItems.length > 1 ? _c('button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.bulkWithdraw",
            modifiers: {
              "bulkWithdraw": true
            }
          }],
          staticClass: "btn-bulk-withdraw mt-0 mb-2 univ-btn"
        }, [_vm._v(" Bulk Withdraw ")]) : _vm._e()], 1)];
      },
      proxy: true
    }, {
      key: "table",
      fn: function fn() {
        return [_c('div', {
          staticClass: "table-responsive"
        }, [_c('table', {
          staticClass: "table group-pending-table"
        }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Group Info")]), _c('th', [_vm._v("Rep")]), _c('th', [_vm._v("Totals")]), _c('th', [_vm._v("Pending Members")]), _c('th', [_vm._v("Actions")])])]), _c('tbody', [_vm.loading ? _c('tr', [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "6"
          }
        }, [_vm._v("Loading...")])]) : _vm._e(), !_vm.loading && _vm.groupRows.records.length === 0 ? _c('tr', [_c('td', {
          staticClass: "text-center text-danger",
          attrs: {
            "colspan": "6"
          }
        }, [_vm._v("No items found")])]) : _vm._e(), _vm._l(_vm.groupRows.records, function (item, index) {
          var _item$pending_submiss;

          return [item ? [_c('tr', {
            key: 'member-' + (item.group_id || index),
            staticClass: "member-row"
          }, [_c('td', [_c('div', {
            staticClass: "d-flex align-items-center gap-2"
          }, [_c('div', {
            staticClass: "d-flex align-items-center gap-2"
          }, [_c('strong', {
            staticClass: "group-name"
          }, [_vm._v(_vm._s(item.group_name))]), item.pending_submission.isNew ? _c('span', {
            staticClass: "badge eventBadge new-group m-0"
          }, [_vm._v("NEW GROUP")]) : _vm._e()])]), item.pending_submission.isNew && item.pending_submission.count < 2 ? _c('div', {
            staticClass: "inline-warning mt-2"
          }, [_c('i', {
            staticClass: "fas fa-info-circle"
          }), _vm._v(" This is a "), _c('strong', {
            staticClass: "ms-1"
          }, [_vm._v("new group")]), _vm._v(". At least "), _c('strong', {
            staticClass: "mx-1"
          }, [_vm._v("2 members")]), _vm._v(" are required to submit enrollment as a group, or you can proceed as an "), _c('strong', {
            staticClass: "ms-1"
          }, [_vm._v("individual enrollment. ")])]) : _vm._e(), _c('div', {
            staticClass: "group-id-small text-muted"
          }, [_vm._v(_vm._s(item.group_code))]), _c('div', {
            staticClass: "group-id-small text-muted"
          }, [_vm._v(_vm._s(item.group_email))]), _c('span', {
            class: item.group_status.toLowerCase() == 'active' ? 'id-status-active' : 'id-status-inactive'
          }, [_vm._v(_vm._s(item.group_status))])]), _c('td', [_c('strong', [_vm._v(_vm._s(item.group_ga_agent_full_name))]), _c('br'), _c('span', {
            staticClass: "text-muted"
          }, [_vm._v(_vm._s(item.group_ga_agent_code))])]), _c('td', [_c('ul', {
            staticClass: "stats-grid"
          }, [_c('li', [_c('strong', [_vm._v("A:")]), _vm._v(" " + _vm._s(item.active_total))]), _c('li', [_c('strong', [_vm._v("W:")]), _vm._v(" " + _vm._s(item.withdraw_total))]), _c('li', [_c('strong', [_vm._v("T:")]), _vm._v(" " + _vm._s(item.termed_total))]), _c('li', [_c('strong', [_vm._v("Total:")]), _vm._v(" " + _vm._s(_vm.getStatTotal(item.active_total, item.withdraw_total, item.termed_total)) + " ")])])]), _c('td', [_c('div', {
            staticClass: "d-flex flex-column align-items-center gap-2 pending-member-cell"
          }, [_c('span', {
            staticClass: "badge eventBadge d-flex align-items-center gap-1 w-100 ms-0"
          }, [_c('span', [_c('i', {
            staticClass: "fas fa-users me-1"
          }), _vm._v(" Pending Members - ")]), _c('span', [_vm._v(" " + _vm._s(((_item$pending_submiss = item.pending_submission) === null || _item$pending_submiss === void 0 ? void 0 : _item$pending_submiss.count) || 0) + " ")])]), _c('div', {
            staticClass: "member-toggle-btn w-100",
            on: {
              "click": function click($event) {
                return _vm.loadGroupMembers(item.group_id);
              }
            }
          }, [_c('i', {
            staticClass: "fas",
            class: _vm.expandedRow === item.group_id ? 'fa-eye-slash' : 'fa-eye'
          }), _c('span', {
            staticClass: "text-nowrap"
          }, [_vm._v(" " + _vm._s(_vm.expandedRow === item.group_id ? "Hide Members" : "View Members") + " ")])])])]), _c('td', [_c('div', {
            staticClass: "action-icons"
          }, [_c('custom-button', {
            directives: [{
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover",
              modifiers: {
                "hover": true
              }
            }],
            staticClass: "submit-action-btn",
            attrs: {
              "iconClass": "fas fa-arrow-up-right-from-square",
              "title": item.pending_submission.isNew && item.pending_submission.count < 2 ? 'Individual Enrollment' : 'Submit Enrollment'
            },
            nativeOn: {
              "click": function click($event) {
                return _vm.selectItem(item);
              }
            }
          }), _c('custom-button', {
            directives: [{
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover",
              modifiers: {
                "hover": true
              }
            }],
            staticClass: "withdraw-action-btn",
            attrs: {
              "iconClass": "fas fa-times-circle",
              "title": "Withdraw Enrollment"
            },
            nativeOn: {
              "click": function click($event) {
                return _vm.selectItemForWithdraw(item);
              }
            }
          })], 1)])]), _vm.expandedRow === item.group_id ? _c('tr', {
            key: 'expanded-' + (item.group_id || index),
            staticClass: "expanded-member-row"
          }, [_c('td', {
            staticClass: "p-0",
            attrs: {
              "colspan": "6"
            }
          }, [_c('div', {
            staticClass: "expanded-content p-3 bg-light"
          }, [_vm.loadingMembers ? _c('div', {
            staticClass: "text-center p-3"
          }, [_c('div', {
            staticClass: "spinner-border text-primary",
            attrs: {
              "role": "status"
            }
          }, [_c('span', {
            staticClass: "visually-hidden"
          }, [_vm._v("Loading...")])]), _c('p', {
            staticClass: "mt-2"
          }, [_vm._v("Loading members...")])]) : [_c('div', {
            staticClass: "expanded-wrapper"
          }, [_c('div', {
            staticClass: "expanded-header d-flex align-items-center gap-3"
          }, [_c('strong', [_vm._v("Pending Members")]), _c('div', {
            staticClass: "form-check m-0"
          }, [_c('input', {
            staticClass: "form-check-input",
            attrs: {
              "type": "checkbox",
              "id": 'selectAllCheckbox-' + item.group_id
            },
            domProps: {
              "checked": _vm.allMembersSelected(item)
            },
            on: {
              "change": function change($event) {
                return _vm.toggleSelectAllMembers(item);
              }
            }
          }), _c('label', {
            staticClass: "form-check-label",
            attrs: {
              "for": 'selectAllCheckbox-' + item.group_id
            }
          }, [_vm._v(" " + _vm._s(_vm.allMembersSelected(item) ? 'Deselect All' : 'Select All') + " ")])]), _c('div', {
            staticClass: "member-toggle-btn",
            on: {
              "click": function click($event) {
                return _vm.openApproveModal(item);
              }
            }
          }, [_c('i', {
            staticClass: "fas fa-file-export"
          }), item.pending_submission.count < 2 ? _c('span', [_vm._v("Individual Enrollment")]) : _c('span', [_vm._v("Submit Enrollment")])]), _c('div', {
            staticClass: "member-toggle-btn withdraw-btn",
            on: {
              "click": function click($event) {
                return _vm.openWithdrawModal(item);
              }
            }
          }, [_c('i', {
            staticClass: "fas fa-times-circle"
          }), _c('span', [_vm._v("Withdraw Enrollment")])])]), item.pending_submission.count < 2 ? _c('div', {
            staticClass: "inline-warning mt-2"
          }, [_c('i', {
            staticClass: "fas fa-info-circle"
          }), _vm._v(" This is a "), _c('strong', {
            staticClass: "ms-1"
          }, [_vm._v("new group")]), _vm._v(". At least "), _c('strong', {
            staticClass: "mx-1"
          }, [_vm._v("2 members")]), _vm._v(" are required to submit enrollment as a group, or you can proceed as an "), _c('strong', {
            staticClass: "ms-1"
          }, [_vm._v("individual enrollment. ")])]) : _vm._e(), _c('div', {
            staticClass: "members-list"
          }, _vm._l(_vm.memberRows.records, function (member) {
            var _member$plan_details, _member$plan_details$, _member$plan_details2, _member$plan_details3;

            return _c('div', {
              key: member.id,
              staticClass: "member-item d-flex align-items-center p-3 border-bottom"
            }, [_c('input', {
              staticClass: "form-check-input me-3",
              attrs: {
                "type": "checkbox"
              },
              domProps: {
                "checked": _vm.isMemberSelected(member)
              },
              on: {
                "change": function change($event) {
                  return _vm.toggleMemberSelection(member, $event);
                }
              }
            }), _c('div', {
              staticClass: "member-info flex-grow-1"
            }, [_c('div', {
              staticClass: "member-info"
            }, [_c('strong', [_vm._v(_vm._s(member.first_name) + " " + _vm._s(member.last_name))]), _c('div', {
              staticClass: "text-muted"
            }, [_c('b', [_vm._v("Policy ID:")]), _vm._v(" " + _vm._s(member.policy_id) + " "), _c('br'), _vm._v(" " + _vm._s(member.user_email) + " • " + _vm._s(member.phone))])])]), _c('div', {
              staticClass: "member-plan ms-auto"
            }, [_vm._v(" " + _vm._s(((_member$plan_details = member.plan_details) === null || _member$plan_details === void 0 ? void 0 : (_member$plan_details$ = _member$plan_details[0]) === null || _member$plan_details$ === void 0 ? void 0 : _member$plan_details$.plan_name_system) || 'N/A') + " — " + _vm._s(((_member$plan_details2 = member.plan_details) === null || _member$plan_details2 === void 0 ? void 0 : (_member$plan_details3 = _member$plan_details2[0]) === null || _member$plan_details3 === void 0 ? void 0 : _member$plan_details3.plan_price) || '0.00') + " "), _c('div', {
              staticClass: "text-muted"
            }, [_c('b', [_vm._v("Effective Date:")]), _vm._v(" " + _vm._s(member.effective_date) + " "), _c('br'), _c('b', [_vm._v("Enrollment Date:")]), _vm._v(" " + _vm._s(member.enrollment_date) + " ")])])]);
          }), 0)])]], 2)])]) : _vm._e()] : _vm._e()];
        })], 2)]), _c('bulk-approval', {
          attrs: {
            "isIndividualEnrollment": _vm.isIndividualEnrollment
          },
          on: {
            "close": _vm.selectNone,
            "submit": _vm.onApproveSubmit
          }
        }), _c('approval', {
          on: {
            "close": _vm.selectNone,
            "submit": _vm.onApproveSubmit
          }
        }), _c('bulk-withdraw', {
          attrs: {
            "isIndividualEnrollment": _vm.isIndividualEnrollment
          },
          on: {
            "close": _vm.selectNone,
            "submit": _vm.onWithdrawSubmit
          }
        }), _c('withdraw', {
          on: {
            "close": _vm.selectNone,
            "submit": _vm.onWithdrawSubmit
          }
        })], 1)];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }